module.exports = __webpack_public_path__ + "static/media/yacar.40d934d1.jpg";